import { sha256 } from 'js-sha256';
import StoreService from "../services/store.service";
import Util from "../utils/util";
let selectedlanguage = Util.getStringFromStorage(Util.APP_LANGUAGE);
export const setCurrentStore = storeId => {
  return (dispatch, getState) => {
    return StoreService.getStoreDetails(storeId)
      .then(data => {
        console.log(data)
        window.togglePreloader(true);
        if (
          data &&
          data.storeId &&
          data.storestatus &&
          data.storestatus === "Active"
        ) {
          if (
            data &&
            data.config &&
            data.config.disableEmailGate &&
            window.location.search.indexOf(data.config.disableEmailGate) > -1
          ) {
            data.emailposition = "NONE";
            // Fire GA: Log email subscription is disabled
          }

          // Clearing email subscription and language banner flag
          const currentTime = new Date().getTime();
          let lastAccessTime = Util.getStringFromStorage(Util.TIMEOUT_TIMESTAMP);
          if (lastAccessTime) {
            lastAccessTime = Number(lastAccessTime);
          }
          if (lastAccessTime && currentTime) {
            const diff = currentTime - lastAccessTime;
            if (data && 
              data.config &&
              data.config.needEmailSubscriptionTimeout === 'true' &&
              data.config.appTimeout && 
              Number(data.config.appTimeout) && 
              diff > Number(data.config.appTimeout)) {
                Util.removeStringFromStorage(Util.EMAIL_SUBSCRIPTION_FLAG);
                Util.removeStringFromStorage(Util.USER_EMAIL);
                Util.removeStringFromStorage(Util.STORE_PIN);
            }
          }
          Util.removeStringFromStorage(Util.ADDITIONAL_APPLIED_COUPON);
          Util.removeStringFromStorage(Util.ADDITIONAL_AUTO_APPLIED_COUPON);
          dispatch({
            type: "SET_STORE",
            store: data
          });

          Util.addObjectToStorage(Util.STORE_DETAILS, data);
          Util.addStringToSessionStorage(Util.IS_ASSOCIATE, (window.location.search.indexOf('utm_source=associate') > -1));
          const isSubscribed = Util.getObjectFromStorage(Util.EMAIL_SUBSCRIPTION_FLAG);

          if (data && data.config) {
            if (data.config.insiderGateGroup) {
              Util.addStringToStorage(Util.INSIDER_GATE_GROUP, data.config.insiderGateGroup);
            } else {
              Util.addStringToStorage(Util.INSIDER_GATE_GROUP, Util.INSIDER_GATE_GROUPS.WITHOUT_INSIDER_GATE);
            }
          }

          const queryParams = Util.getQueryParams();
          if (Util.isECatalogueFlow() && queryParams && queryParams.target) {
            const pathToRedirect = '/' + queryParams.target;

            if (data && data.config && data.config.preferredLanguage) {
              if (selectedlanguage != data.config.preferredLanguage) {
                Util.addStringToStorage(
                  Util.APP_LANGUAGE,
                  data.config.preferredLanguage
                );
              }
            } else {
              Util.addStringToStorage(Util.APP_LANGUAGE, selectedlanguage);
            }
            StoreService.startSession('')
            .then(data => {
              if (data.config && data.config.preferredLanguage && data.config.preferredLanguage == 'en-us') {
                Util.gotoRoute(pathToRedirect, this.props.history);
                window.togglePreloader(true);
              } else {
                window.location.href = pathToRedirect;
                window.togglePreloader(true);
              }
            })
            .catch(error => {
              if (data.config && data.config.preferredLanguage && data.config.preferredLanguage == 'en-us') {
                Util.gotoRoute(pathToRedirect + queryParam, this.props.history);
              } else {
                window.location.href = pathToRedirect + queryParams.target;
              }
            });

          } else {
            window.togglePreloader(false);
            if (
              (data.emailposition === Util.POST_EMAIL_CAPTURE ||
                data.emailposition === "NONE" ||
                (data.emailposition === Util.PRE_EMAIL_CAPTURE &&
                  isSubscribed)) &&
              !data.pinValidationActivated &&
              data.config &&
              data.config.needUngatedRedirect == "true"
            ) {
              window.togglePreloader(true);
              if (data && data.config && data.config.preferredLanguage) {
                if (selectedlanguage != data.config.preferredLanguage) {
                  Util.addStringToStorage(
                    Util.APP_LANGUAGE,
                    data.config.preferredLanguage
                  );
                }
              } else {
                Util.addStringToStorage(Util.APP_LANGUAGE, selectedlanguage);
              }
              let queryParam = window.location.search;
              if (queryParam) {
                queryParam += "&ungated=true";
              } else {
                queryParam = "?ungated=true";
              }
              StoreService.startSession('')
                .then(data => {
                  if (data.config && data.config.preferredLanguage && data.config.preferredLanguage == 'en-us') {
                    Util.gotoRoute('/home' + queryParam, this.props.history);
                  } else {
                    window.location.href = "/home" + queryParam;
                  }
                })
                .catch(error => {
                  if (data.config && data.config.preferredLanguage && data.config.preferredLanguage == 'en-us') {
                    Util.gotoRoute('/home' + queryParam, this.props.history);
                  } else {
                    window.location.href = "/home" + queryParam;
                  }
                });
            } else {
              if (data && data.config && data.config.preferredLanguage) {
                if (selectedlanguage != data.config.preferredLanguage) {
                  Util.addStringToStorage(
                    Util.APP_LANGUAGE,
                    data.config.preferredLanguage
                  );
                  window.location.reload();
                }
              } else {
                Util.addStringToStorage(Util.APP_LANGUAGE, selectedlanguage);
              }
            }
          }

          // Redirecting to offer page for ungated stores
          
          
          dataLayer.push({
            'event': 'dataLayer-initialized',
            'customAttributes':Util.getCustomAttributes(),
            'userID': Util.getEmailId(),
            'language': Util.getSelectedLanguage(),
            'pageName': 'lovescanshop',
            'pageType': 'homepage',
            'storeID': data.storeId,
            'storeDesc': data.name,
            'flowConfig': Util.getGAFlowConfig(),
            'signedIn': (Util.isUserLoggedIn() == Util.LOGGEDIN_STATUS.LOGGED_IN) ? 'signed-in user' : 'guest'
          });
          dataLayer.push({
            'event': 'appPageView',
            'appPageName': 'lovescanshop',
            'flowConfig': Util.getGAFlowConfig()
          });
          //Google Analytics: Log store name to store custom dimension
          dataLayer.push({
            store: data.name,
            event: "storeLogged"
          });
          
          Util.addStringToStorage(Util.TIMEOUT_TIMESTAMP, currentTime);
          return data;
        } else {
          //Google Analytics: Log invalid stores
          dataLayer.push({
            errorValue: "Invalid store detected",
            event: "errorLogged",
            eventCallback: () => {
              window.location.href = "/store-not-active";
            },
            eventTimeout: 2000
          });
        }

        return data;
      })
      .catch(e => {
        console.log(e);
        window.location.href = "/error";
      });
  };
};
export const subscribeNewsletter = (request, callBackFn = null) => {
  return (dispatch, getState) => {
    if (request && (!request.emailOptIn || request.emailOptIn == 'false')) {
      request.email = '';
    }
    StoreService.subscribeNewsletter(request)
      .then(data => {
        // GA Tapestry
        // Setting Encrypted email to storage
        const encEmail = sha256(request.email);
        dataLayer.push({
          'event': 'flowInteraction',
          'userID': encEmail,
          'flowAction': 'email entry success',
          'flowConfig': Util.getGAFlowConfig()
        });
        if (data && data.message === "Success") {

        }
        if (callBackFn) {
          callBackFn(data);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
};

export const getScannerLibFiles = (url) => {
  return (dispatch, getState) => {
    return StoreService.getLibFiles(url)
      .then(data => {
      })
      .catch(e => {
        console.log(e);
      });
  };
};


export const setPinValidity = (validity) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SET_PIN_VALIDITY",
      payload: validity
    });
  };
}

export const setEmailOptIn = (status) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SET_EMAIL_OPT_IN",
      payload: status
    });
  };
}